
import { Component, Prop, Vue } from 'vue-property-decorator'
import { BusinessCategory } from '../types'

@Component
export default class NavSidebar extends Vue {
  @Prop({ type: Array, required: true }) readonly categories!: BusinessCategory[]
  @Prop({ type: String, default: '' }) readonly activeEntryId!: string
}
